import React from "react"
// NOTE: intentionally uses the older @components/Button so extracted dashboard
// dialogs keep pixel-parity with the shipped FSP-admin look. @UILibrary/Button
// has a different variant API/appearance (no warning variant).
import { Button } from "@components/Button"
import { Modal } from "./Modal"

type Props = {
  open: boolean
  title: string
  message: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  busy?: boolean
  onConfirm: () => void
  onClose: () => void
}

// Small confirmation step used before irreversible or heavy actions (export,
// bulk transfer, deactivate). Wraps the shared Modal shell.
export const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  busy = false,
  onConfirm,
  onClose,
}) => (
  <Modal open={open} title={title} onClose={onClose}>
    <div className="fsp-admin__confirm-body">{message}</div>
    <div className="fsp-admin__modal-actions">
      <Button secondary type="button" onClick={onClose} disabled={busy}>
        {cancelLabel}
      </Button>
      <Button {...(danger ? { warning: true } : { primary: true })} type="button" onClick={onConfirm} disabled={busy}>
        {busy ? "Working…" : confirmLabel}
      </Button>
    </div>
  </Modal>
)
